import React from "react";
import { ReactComponent as ValidIcon } from "assets/valid.svg";
import { ReactComponent as ErrorIcon } from "assets/error.svg";

import "./index.scss";

export const InputLabel = React.forwardRef(
  (
    {
      id,
      label,
      required,
      customClassname,
      hasError = false,
      showValidationIcon = false,
      hintTooltip = null,
      preIcon = null,
      disablePopUp,
      ...props
    },
    ref
  ) => {
    const handleInvalid = (event) => {
      if (disablePopUp) event.preventDefault();
    };

    const renderValidationIcon = () => {
      if (!showValidationIcon) return null;
      return hasError ? (
        <ErrorIcon
          aria-label="Field has an error"
          role="img"
          className="icon"
        />
      ) : (
        <ValidIcon aria-label="Field is valid" role="img" className="icon" />
      );
    };

    return (
      <div className={`input-label ${customClassname || ""}`}>
        {label && (
          <div className="label-container">
            <label htmlFor={id}>
              {label} <span>{required && "*"}</span>
            </label>
            {hintTooltip && hintTooltip}
          </div>
        )}
        {preIcon && preIcon}
        <input
          id={id}
          ref={ref}
          className={hasError ? "input-label--error" : ""}
          onInvalid={handleInvalid}
          {...props}
        />
        {renderValidationIcon()}
      </div>
    );
  }
);

InputLabel.displayName = "InputLabel";
